import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: 300px;
`;

export default Container;
